{
  "kk": {
    "flightDetailsBs": {
      "title": "Рейс туралы мәлімет"
    },
    "routeDetailsBs": {
      "title": "Маршрут мәліметтері"
    }
  },
  "ru": {
    "flightDetailsBs": {
      "title": "Детали рейса"
    },
    "routeDetailsBs": {
      "title": "Детали маршрута"
    }
  },
  "en": {
    "flightDetailsBs": {
      "title": "Flight details"
    },
    "routeDetailsBs": {
      "title": "Route details"
    }
  }
}
